function Un(e, t, n = "info") {
    t = typeof t == "object" ? JSON.stringify(t, null, 4) : t, console[n](`%c surfscaler%c@v${window.ecom.version}%c • %c[${e}::${n.toUpperCase()}] %c${t}`, "color: #66C3ED; font-weight: bold;", "color: #AAAAAA;", "color: inherit;", "color: lightgreen;", "color: inherit;")
}
window.ecom = window.ecom || {};
window.ecom.version = "1.2.3";
window.ecom.log = Un;
window.ecom.log("Coresurfscaler");
var Ge = !1,
    Qe = !1,
    N = [],
    Ie = -1;

function Vn(e) {
    Zn(e)
}

function Zn(e) {
    N.includes(e) || N.push(e), Xn()
}

function $n(e) {
    let t = N.indexOf(e);
    t !== -1 && t > Ie && N.splice(t, 1)
}

function Xn() {
    !Qe && !Ge && (Ge = !0, queueMicrotask(Yn))
}

function Yn() {
    Ge = !1, Qe = !0;
    for (let e = 0; e < N.length; e++) N[e](), Ie = e;
    N.length = 0, Ie = -1, Qe = !1
}
var z, H, U, Mt, qe = !0;

function er(e) {
    qe = !1, e(), qe = !0
}

function tr(e) {
    z = e.reactive, U = e.release, H = t => e.effect(t, {
        scheduler: n => {
            qe ? Vn(n) : n()
        }
    }), Mt = e.raw
}

function mt(e) {
    H = e
}

function nr(e) {
    let t = () => {};
    return [i => {
        let c = H(i);
        return e._x_effects || (e._x_effects = new Set, e._x_runEffects = () => {
            e._x_effects.forEach(o => o())
        }), e._x_effects.add(c), t = () => {
            c !== void 0 && (e._x_effects.delete(c), U(c))
        }, c
    }, () => {
        t()
    }]
}

function Gt(e, t) {
    let n = !0,
        i, c = H(() => {
            let o = e();
            JSON.stringify(o), n ? i = o : queueMicrotask(() => {
                t(o, i), i = o
            }), n = !1
        });
    return () => U(c)
}
var Qt = [],
    It = [],
    qt = [];

function rr(e) {
    qt.push(e)
}

function Ze(e, t) {
    typeof t == "function" ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t)) : (t = e, It.push(t))
}

function Lt(e) {
    Qt.push(e)
}

function Tt(e, t, n) {
    e._x_attributeCleanups || (e._x_attributeCleanups = {}), e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []), e._x_attributeCleanups[t].push(n)
}

function Nt(e, t) {
    e._x_attributeCleanups && Object.entries(e._x_attributeCleanups).forEach(([n, i]) => {
        (t === void 0 || t.includes(n)) && (i.forEach(c => c()), delete e._x_attributeCleanups[n])
    })
}

function ir(e) {
    for (e._x_effects?.forEach($n); e._x_cleanups?.length;) e._x_cleanups.pop()()
}
var $e = new MutationObserver(tt),
    Xe = !1;

function Ye() {
    $e.observe(document, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeOldValue: !0
    }), Xe = !0
}

function Bt() {
    or(), $e.disconnect(), Xe = !1
}
var Y = [];

function or() {
    let e = $e.takeRecords();
    Y.push(() => e.length > 0 && tt(e));
    let t = Y.length;
    queueMicrotask(() => {
        if (Y.length === t)
            for (; Y.length > 0;) Y.shift()()
    })
}

function b(e) {
    if (!Xe) return e();
    Bt();
    let t = e();
    return Ye(), t
}
var et = !1,
    _e = [];

function cr() {
    et = !0
}

function ar() {
    et = !1, tt(_e), _e = []
}

function tt(e) {
    if (et) {
        _e = _e.concat(e);
        return
    }
    let t = [],
        n = new Set,
        i = new Map,
        c = new Map;
    for (let o = 0; o < e.length; o++)
        if (!e[o].target._x_ignoreMutationObserver && (e[o].type === "childList" && (e[o].removedNodes.forEach(r => {
                r.nodeType === 1 && r._x_marker && n.add(r)
            }), e[o].addedNodes.forEach(r => {
                if (r.nodeType === 1) {
                    if (n.has(r)) {
                        n.delete(r);
                        return
                    }
                    r._x_marker || t.push(r)
                }
            })), e[o].type === "attributes")) {
            let r = e[o].target,
                a = e[o].attributeName,
                s = e[o].oldValue,
                u = () => {
                    i.has(r) || i.set(r, []), i.get(r).push({
                        name: a,
                        value: r.getAttribute(a)
                    })
                },
                l = () => {
                    c.has(r) || c.set(r, []), c.get(r).push(a)
                };
            r.hasAttribute(a) && s === null ? u() : r.hasAttribute(a) ? (l(), u()) : l()
        } c.forEach((o, r) => {
        Nt(r, o)
    }), i.forEach((o, r) => {
        Qt.forEach(a => a(r, o))
    });
    for (let o of n) t.some(r => r.contains(o)) || It.forEach(r => r(o));
    for (let o of t) o.isConnected && qt.forEach(r => r(o));
    t = null, n = null, i = null, c = null
}

function jt(e) {
    return ae(D(e))
}

function ce(e, t, n) {
    return e._x_dataStack = [t, ...D(n || e)], () => {
        e._x_dataStack = e._x_dataStack.filter(i => i !== t)
    }
}

function D(e) {
    return e._x_dataStack ? e._x_dataStack : typeof ShadowRoot == "function" && e instanceof ShadowRoot ? D(e.host) : e.parentNode ? D(e.parentNode) : []
}

function ae(e) {
    return new Proxy({
        objects: e
    }, sr)
}
var sr = {
    ownKeys({
        objects: e
    }) {
        return Array.from(new Set(e.flatMap(t => Object.keys(t))))
    },
    has({
        objects: e
    }, t) {
        return t == Symbol.unscopables ? !1 : e.some(n => Object.prototype.hasOwnProperty.call(n, t) || Reflect.has(n, t))
    },
    get({
        objects: e
    }, t, n) {
        return t == "toJSON" ? ur : Reflect.get(e.find(i => Reflect.has(i, t)) || {}, t, n)
    },
    set({
        objects: e
    }, t, n, i) {
        const c = e.find(r => Object.prototype.hasOwnProperty.call(r, t)) || e[e.length - 1],
            o = Object.getOwnPropertyDescriptor(c, t);
        return o?.set && o?.get ? o.set.call(i, n) || !0 : Reflect.set(c, t, n)
    }
};

function ur() {
    return Reflect.ownKeys(this).reduce((t, n) => (t[n] = Reflect.get(this, n), t), {})
}

function Jt(e) {
    let t = i => typeof i == "object" && !Array.isArray(i) && i !== null,
        n = (i, c = "") => {
            Object.entries(Object.getOwnPropertyDescriptors(i)).forEach(([o, {
                value: r,
                enumerable: a
            }]) => {
                if (a === !1 || r === void 0 || typeof r == "object" && r !== null && r.__v_skip) return;
                let s = c === "" ? o : `${c}.${o}`;
                typeof r == "object" && r !== null && r._x_interceptor ? i[o] = r.initialize(e, s, o) : t(r) && r !== i && !(r instanceof Element) && n(r, s)
            })
        };
    return n(e)
}

function Kt(e, t = () => {}) {
    let n = {
        initialValue: void 0,
        _x_interceptor: !0,
        initialize(i, c, o) {
            return e(this.initialValue, () => fr(i, c), r => Le(i, c, r), c, o)
        }
    };
    return t(n), i => {
        if (typeof i == "object" && i !== null && i._x_interceptor) {
            let c = n.initialize.bind(n);
            n.initialize = (o, r, a) => {
                let s = i.initialize(o, r, a);
                return n.initialValue = s, c(o, r, a)
            }
        } else n.initialValue = i;
        return n
    }
}

function fr(e, t) {
    return t.split(".").reduce((n, i) => n[i], e)
}

function Le(e, t, n) {
    if (typeof t == "string" && (t = t.split(".")), t.length === 1) e[t[0]] = n;
    else {
        if (t.length === 0) throw error;
        return e[t[0]] || (e[t[0]] = {}), Le(e[t[0]], t.slice(1), n)
    }
}
var Ht = {};

function R(e, t) {
    Ht[e] = t
}

function Te(e, t) {
    let n = lr(t);
    return Object.entries(Ht).forEach(([i, c]) => {
        Object.defineProperty(e, `$${i}`, {
            get() {
                return c(t, n)
            },
            enumerable: !1
        })
    }), e
}

function lr(e) {
    let [t, n] = Zt(e), i = {
        interceptor: Kt,
        ...t
    };
    return Ze(e, n), i
}

function dr(e, t, n, ...i) {
    try {
        return n(...i)
    } catch (c) {
        oe(c, e, t)
    }
}

function oe(e, t, n = void 0) {
    e = Object.assign(e ?? {
        message: "No error message given."
    }, {
        el: t,
        expression: n
    }), console.warn(`Alpine Expression Error: ${e.message}

${n?'Expression: "'+n+`"

`:""}`, t), setTimeout(() => {
        throw e
    }, 0)
}
var We = !0;

function Dt(e) {
    let t = We;
    We = !1;
    let n = e();
    return We = t, n
}

function B(e, t, n = {}) {
    let i;
    return k(e, t)(c => i = c, n), i
}

function k(...e) {
    return Ft(...e)
}
var Ft = zt;

function xr(e) {
    Ft = e
}

function zt(e, t) {
    let n = {};
    Te(n, e);
    let i = [n, ...D(e)],
        c = typeof t == "function" ? Wr(i, t) : _r(i, t, e);
    return dr.bind(null, e, t, c)
}

function Wr(e, t) {
    return (n = () => {}, {
        scope: i = {},
        params: c = [],
        context: o
    } = {}) => {
        let r = t.apply(ae([i, ...e]), c);
        he(n, r)
    }
}
var Pe = {};

function pr(e, t) {
    if (Pe[e]) return Pe[e];
    let n = Object.getPrototypeOf(async function() {}).constructor,
        i = /^[\n\s]*if.*\(.*\)/.test(e.trim()) || /^(let|const)\s/.test(e.trim()) ? `(async()=>{ ${e} })()` : e,
        o = (() => {
            try {
                let r = new n(["__self", "scope"], `with (scope) { __self.result = ${i} }; __self.finished = true; return __self.result;`);
                return Object.defineProperty(r, "name", {
                    value: `[Alpine] ${e}`
                }), r
            } catch (r) {
                return oe(r, t, e), Promise.resolve()
            }
        })();
    return Pe[e] = o, o
}

function _r(e, t, n) {
    let i = pr(t, n);
    return (c = () => {}, {
        scope: o = {},
        params: r = [],
        context: a
    } = {}) => {
        i.result = void 0, i.finished = !1;
        let s = ae([o, ...e]);
        if (typeof i == "function") {
            let u = i.call(a, i, s).catch(l => oe(l, n, t));
            i.finished ? (he(c, i.result, s, r, n), i.result = void 0) : u.then(l => {
                he(c, l, s, r, n)
            }).catch(l => oe(l, n, t)).finally(() => i.result = void 0)
        }
    }
}

function he(e, t, n, i, c) {
    if (We && typeof t == "function") {
        let o = t.apply(n, i);
        o instanceof Promise ? o.then(r => he(e, r, n, i)).catch(r => oe(r, c, t)) : e(o)
    } else typeof t == "object" && t instanceof Promise ? t.then(o => e(o)) : e(t)
}
var nt = "x-";

function V(e = "") {
    return nt + e
}

function hr(e) {
    nt = e
}
var me = {};

function y(e, t) {
    return me[e] = t, {
        before(n) {
            if (!me[n]) {
                console.warn(String.raw`Cannot find directive \`${n}\`. \`${e}\` will use the default order of execution`);
                return
            }
            const i = T.indexOf(n);
            T.splice(i >= 0 ? i : T.indexOf("DEFAULT"), 0, e)
        }
    }
}

function mr(e) {
    return Object.keys(me).includes(e)
}

function rt(e, t, n) {
    if (t = Array.from(t), e._x_virtualDirectives) {
        let o = Object.entries(e._x_virtualDirectives).map(([a, s]) => ({
                name: a,
                value: s
            })),
            r = Ut(o);
        o = o.map(a => r.find(s => s.name === a.name) ? {
            name: `x-bind:${a.name}`,
            value: `"${a.value}"`
        } : a), t = t.concat(o)
    }
    let i = {};
    return t.map(Yt((o, r) => i[o] = r)).filter(tn).map(br(i, n)).sort(yr).map(o => Sr(e, o))
}

function Ut(e) {
    return Array.from(e).map(Yt()).filter(t => !tn(t))
}
var Ne = !1,
    ne = new Map,
    Vt = Symbol();

function gr(e) {
    Ne = !0;
    let t = Symbol();
    Vt = t, ne.set(t, []);
    let n = () => {
            for (; ne.get(t).length;) ne.get(t).shift()();
            ne.delete(t)
        },
        i = () => {
            Ne = !1, n()
        };
    e(n), i()
}

function Zt(e) {
    let t = [],
        n = a => t.push(a),
        [i, c] = nr(e);
    return t.push(c), [{
        Alpine: se,
        effect: i,
        cleanup: n,
        evaluateLater: k.bind(k, e),
        evaluate: B.bind(B, e)
    }, () => t.forEach(a => a())]
}

function Sr(e, t) {
    let n = () => {},
        i = me[t.type] || n,
        [c, o] = Zt(e);
    Tt(e, t.original, o);
    let r = () => {
        e._x_ignore || e._x_ignoreSelf || (i.inline && i.inline(e, t, c), i = i.bind(i, e, t, c), Ne ? ne.get(Vt).push(i) : i())
    };
    return r.runCleanups = o, r
}
var $t = (e, t) => ({
        name: n,
        value: i
    }) => (n.startsWith(e) && (n = n.replace(e, t)), {
        name: n,
        value: i
    }),
    Xt = e => e;

function Yt(e = () => {}) {
    return ({
        name: t,
        value: n
    }) => {
        let {
            name: i,
            value: c
        } = en.reduce((o, r) => r(o), {
            name: t,
            value: n
        });
        return i !== t && e(i, t), {
            name: i,
            value: c
        }
    }
}
var en = [];

function it(e) {
    en.push(e)
}

function tn({
    name: e
}) {
    return nn().test(e)
}
var nn = () => new RegExp(`^${nt}([^:^.]+)\\b`);

function br(e, t) {
    return ({
        name: n,
        value: i
    }) => {
        let c = n.match(nn()),
            o = n.match(/:([a-zA-Z0-9\-_:]+)/),
            r = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
            a = t || e[n] || n;
        return {
            type: c ? c[1] : null,
            value: o ? o[1] : null,
            modifiers: r.map(s => s.replace(".", "")),
            expression: i,
            original: a
        }
    }
}
var Be = "DEFAULT",
    T = ["ignore", "ref", "data", "id", "anchor", "bind", "init", "for", "model", "modelable", "transition", "show", "if", Be, "teleport"];

function yr(e, t) {
    let n = T.indexOf(e.type) === -1 ? Be : e.type,
        i = T.indexOf(t.type) === -1 ? Be : t.type;
    return T.indexOf(n) - T.indexOf(i)
}

function re(e, t, n = {}) {
    e.dispatchEvent(new CustomEvent(t, {
        detail: n,
        bubbles: !0,
        composed: !0,
        cancelable: !0
    }))
}

function K(e, t) {
    if (typeof ShadowRoot == "function" && e instanceof ShadowRoot) {
        Array.from(e.children).forEach(c => K(c, t));
        return
    }
    let n = !1;
    if (t(e, () => n = !0), n) return;
    let i = e.firstElementChild;
    for (; i;) K(i, t), i = i.nextElementSibling
}

function C(e, ...t) {
    console.warn(`Alpine Warning: ${e}`, ...t)
}
var gt = !1;

function vr() {
    gt && C("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."), gt = !0, document.body || C("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"), re(document, "alpine:init"), re(document, "alpine:initializing"), Ye(), rr(t => M(t, K)), Ze(t => $(t)), Lt((t, n) => {
        rt(t, n).forEach(i => i())
    });
    let e = t => !be(t.parentElement, !0);
    Array.from(document.querySelectorAll(cn().join(","))).filter(e).forEach(t => {
        M(t)
    }), re(document, "alpine:initialized"), setTimeout(() => {
        Or()
    })
}
var ot = [],
    rn = [];

function on() {
    return ot.map(e => e())
}

function cn() {
    return ot.concat(rn).map(e => e())
}

function an(e) {
    ot.push(e)
}

function sn(e) {
    rn.push(e)
}

function be(e, t = !1) {
    return Z(e, n => {
        if ((t ? cn() : on()).some(c => n.matches(c))) return !0
    })
}

function Z(e, t) {
    if (e) {
        if (t(e)) return e;
        if (e._x_teleportBack && (e = e._x_teleportBack), !!e.parentElement) return Z(e.parentElement, t)
    }
}

function kr(e) {
    return on().some(t => e.matches(t))
}
var un = [];

function Cr(e) {
    un.push(e)
}
var wr = 1;

function M(e, t = K, n = () => {}) {
    Z(e, i => i._x_ignore) || gr(() => {
        t(e, (i, c) => {
            i._x_marker || (n(i, c), un.forEach(o => o(i, c)), rt(i, i.attributes).forEach(o => o()), i._x_ignore || (i._x_marker = wr++), i._x_ignore && c())
        })
    })
}

function $(e, t = K) {
    t(e, n => {
        ir(n), Nt(n), delete n._x_marker
    })
}

function Or() {
    [
        ["ui", "dialog", ["[x-dialog], [x-popover]"]],
        ["anchor", "anchor", ["[x-anchor]"]],
        ["sort", "sort", ["[x-sort]"]]
    ].forEach(([t, n, i]) => {
        mr(n) || i.some(c => {
            if (document.querySelector(c)) return C(`found "${c}", but missing ${t} plugin`), !0
        })
    })
}
var je = [],
    ct = !1;

function at(e = () => {}) {
    return queueMicrotask(() => {
        ct || setTimeout(() => {
            Je()
        })
    }), new Promise(t => {
        je.push(() => {
            e(), t()
        })
    })
}

function Je() {
    for (ct = !1; je.length;) je.shift()()
}

function Pr() {
    ct = !0
}

function st(e, t) {
    return Array.isArray(t) ? St(e, t.join(" ")) : typeof t == "object" && t !== null ? Rr(e, t) : typeof t == "function" ? st(e, t()) : St(e, t)
}

function St(e, t) {
    let n = c => c.split(" ").filter(o => !e.classList.contains(o)).filter(Boolean),
        i = c => (e.classList.add(...c), () => {
            e.classList.remove(...c)
        });
    return t = t === !0 ? t = "" : t || "", i(n(t))
}

function Rr(e, t) {
    let n = a => a.split(" ").filter(Boolean),
        i = Object.entries(t).flatMap(([a, s]) => s ? n(a) : !1).filter(Boolean),
        c = Object.entries(t).flatMap(([a, s]) => s ? !1 : n(a)).filter(Boolean),
        o = [],
        r = [];
    return c.forEach(a => {
        e.classList.contains(a) && (e.classList.remove(a), r.push(a))
    }), i.forEach(a => {
        e.classList.contains(a) || (e.classList.add(a), o.push(a))
    }), () => {
        r.forEach(a => e.classList.add(a)), o.forEach(a => e.classList.remove(a))
    }
}

function ye(e, t) {
    return typeof t == "object" && t !== null ? Ar(e, t) : Er(e, t)
}

function Ar(e, t) {
    let n = {};
    return Object.entries(t).forEach(([i, c]) => {
        n[i] = e.style[i], i.startsWith("--") || (i = Mr(i)), e.style.setProperty(i, c)
    }), setTimeout(() => {
        e.style.length === 0 && e.removeAttribute("style")
    }), () => {
        ye(e, n)
    }
}

function Er(e, t) {
    let n = e.getAttribute("style", t);
    return e.setAttribute("style", t), () => {
        e.setAttribute("style", n || "")
    }
}

function Mr(e) {
    return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
}

function Ke(e, t = () => {}) {
    let n = !1;
    return function() {
        n ? t.apply(this, arguments) : (n = !0, e.apply(this, arguments))
    }
}
y("transition", (e, {
    value: t,
    modifiers: n,
    expression: i
}, {
    evaluate: c
}) => {
    typeof i == "function" && (i = c(i)), i !== !1 && (!i || typeof i == "boolean" ? Qr(e, n, t) : Gr(e, i, t))
});

function Gr(e, t, n) {
    fn(e, st, ""), {
        enter: c => {
            e._x_transition.enter.during = c
        },
        "enter-start": c => {
            e._x_transition.enter.start = c
        },
        "enter-end": c => {
            e._x_transition.enter.end = c
        },
        leave: c => {
            e._x_transition.leave.during = c
        },
        "leave-start": c => {
            e._x_transition.leave.start = c
        },
        "leave-end": c => {
            e._x_transition.leave.end = c
        }
    } [n](t)
}

function Qr(e, t, n) {
    fn(e, ye);
    let i = !t.includes("in") && !t.includes("out") && !n,
        c = i || t.includes("in") || ["enter"].includes(n),
        o = i || t.includes("out") || ["leave"].includes(n);
    t.includes("in") && !i && (t = t.filter((W, m) => m < t.indexOf("out"))), t.includes("out") && !i && (t = t.filter((W, m) => m > t.indexOf("out")));
    let r = !t.includes("opacity") && !t.includes("scale"),
        a = r || t.includes("opacity"),
        s = r || t.includes("scale"),
        u = a ? 0 : 1,
        l = s ? ee(t, "scale", 95) / 100 : 1,
        p = ee(t, "delay", 0) / 1e3,
        h = ee(t, "origin", "center"),
        _ = "opacity, transform",
        f = ee(t, "duration", 150) / 1e3,
        d = ee(t, "duration", 75) / 1e3,
        x = "cubic-bezier(0.4, 0.0, 0.2, 1)";
    c && (e._x_transition.enter.during = {
        transformOrigin: h,
        transitionDelay: `${p}s`,
        transitionProperty: _,
        transitionDuration: `${f}s`,
        transitionTimingFunction: x
    }, e._x_transition.enter.start = {
        opacity: u,
        transform: `scale(${l})`
    }, e._x_transition.enter.end = {
        opacity: 1,
        transform: "scale(1)"
    }), o && (e._x_transition.leave.during = {
        transformOrigin: h,
        transitionDelay: `${p}s`,
        transitionProperty: _,
        transitionDuration: `${d}s`,
        transitionTimingFunction: x
    }, e._x_transition.leave.start = {
        opacity: 1,
        transform: "scale(1)"
    }, e._x_transition.leave.end = {
        opacity: u,
        transform: `scale(${l})`
    })
}

function fn(e, t, n = {}) {
    e._x_transition || (e._x_transition = {
        enter: {
            during: n,
            start: n,
            end: n
        },
        leave: {
            during: n,
            start: n,
            end: n
        },
        in(i = () => {}, c = () => {}) {
            He(e, t, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, i, c)
        },
        out(i = () => {}, c = () => {}) {
            He(e, t, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, i, c)
        }
    })
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(e, t, n, i) {
    const c = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let o = () => c(n);
    if (t) {
        e._x_transition && (e._x_transition.enter || e._x_transition.leave) ? e._x_transition.enter && (Object.entries(e._x_transition.enter.during).length || Object.entries(e._x_transition.enter.start).length || Object.entries(e._x_transition.enter.end).length) ? e._x_transition.in(n) : o() : e._x_transition ? e._x_transition.in(n) : o();
        return
    }
    e._x_hidePromise = e._x_transition ? new Promise((r, a) => {
        e._x_transition.out(() => {}, () => r(i)), e._x_transitioning && e._x_transitioning.beforeCancel(() => a({
            isFromCancelledTransition: !0
        }))
    }) : Promise.resolve(i), queueMicrotask(() => {
        let r = ln(e);
        r ? (r._x_hideChildren || (r._x_hideChildren = []), r._x_hideChildren.push(e)) : c(() => {
            let a = s => {
                let u = Promise.all([s._x_hidePromise, ...(s._x_hideChildren || []).map(a)]).then(([l]) => l?.());
                return delete s._x_hidePromise, delete s._x_hideChildren, u
            };
            a(e).catch(s => {
                if (!s.isFromCancelledTransition) throw s
            })
        })
    })
};

function ln(e) {
    let t = e.parentNode;
    if (t) return t._x_hidePromise ? t : ln(t)
}

function He(e, t, {
    during: n,
    start: i,
    end: c
} = {}, o = () => {}, r = () => {}) {
    if (e._x_transitioning && e._x_transitioning.cancel(), Object.keys(n).length === 0 && Object.keys(i).length === 0 && Object.keys(c).length === 0) {
        o(), r();
        return
    }
    let a, s, u;
    Ir(e, {
        start() {
            a = t(e, i)
        },
        during() {
            s = t(e, n)
        },
        before: o,
        end() {
            a(), u = t(e, c)
        },
        after: r,
        cleanup() {
            s(), u()
        }
    })
}

function Ir(e, t) {
    let n, i, c, o = Ke(() => {
        b(() => {
            n = !0, i || t.before(), c || (t.end(), Je()), t.after(), e.isConnected && t.cleanup(), delete e._x_transitioning
        })
    });
    e._x_transitioning = {
        beforeCancels: [],
        beforeCancel(r) {
            this.beforeCancels.push(r)
        },
        cancel: Ke(function() {
            for (; this.beforeCancels.length;) this.beforeCancels.shift()();
            o()
        }),
        finish: o
    }, b(() => {
        t.start(), t.during()
    }), Pr(), requestAnimationFrame(() => {
        if (n) return;
        let r = Number(getComputedStyle(e).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3,
            a = Number(getComputedStyle(e).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        r === 0 && (r = Number(getComputedStyle(e).animationDuration.replace("s", "")) * 1e3), b(() => {
            t.before()
        }), i = !0, requestAnimationFrame(() => {
            n || (b(() => {
                t.end()
            }), Je(), setTimeout(e._x_transitioning.finish, r + a), c = !0)
        })
    })
}

function ee(e, t, n) {
    if (e.indexOf(t) === -1) return n;
    const i = e[e.indexOf(t) + 1];
    if (!i || t === "scale" && isNaN(i)) return n;
    if (t === "duration" || t === "delay") {
        let c = i.match(/([0-9]+)ms/);
        if (c) return c[1]
    }
    return t === "origin" && ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2]) ? [i, e[e.indexOf(t) + 2]].join(" ") : i
}
var Q = !1;

function q(e, t = () => {}) {
    return (...n) => Q ? t(...n) : e(...n)
}

function qr(e) {
    return (...t) => Q && e(...t)
}
var dn = [];

function ve(e) {
    dn.push(e)
}

function Lr(e, t) {
    dn.forEach(n => n(e, t)), Q = !0, xn(() => {
        M(t, (n, i) => {
            i(n, () => {})
        })
    }), Q = !1
}
var De = !1;

function Tr(e, t) {
    t._x_dataStack || (t._x_dataStack = e._x_dataStack), Q = !0, De = !0, xn(() => {
        Nr(t)
    }), Q = !1, De = !1
}

function Nr(e) {
    let t = !1;
    M(e, (i, c) => {
        K(i, (o, r) => {
            if (t && kr(o)) return r();
            t = !0, c(o, r)
        })
    })
}

function xn(e) {
    let t = H;
    mt((n, i) => {
        let c = t(n);
        return U(c), () => {}
    }), e(), mt(t)
}

function Wn(e, t, n, i = []) {
    switch (e._x_bindings || (e._x_bindings = z({})), e._x_bindings[t] = n, t = i.includes("camel") ? zr(t) : t, t) {
        case "value":
            Br(e, n);
            break;
        case "style":
            Jr(e, n);
            break;
        case "class":
            jr(e, n);
            break;
        case "selected":
        case "checked":
            Kr(e, t, n);
            break;
        default:
            pn(e, t, n);
            break
    }
}

function Br(e, t) {
    if (mn(e)) e.attributes.value === void 0 && (e.value = t), window.fromModel && (typeof t == "boolean" ? e.checked = pe(e.value) === t : e.checked = bt(e.value, t));
    else if (ut(e)) Number.isInteger(t) ? e.value = t : !Array.isArray(t) && typeof t != "boolean" && ![null, void 0].includes(t) ? e.value = String(t) : Array.isArray(t) ? e.checked = t.some(n => bt(n, e.value)) : e.checked = !!t;
    else if (e.tagName === "SELECT") Fr(e, t);
    else {
        if (e.value === t) return;
        e.value = t === void 0 ? "" : t
    }
}

function jr(e, t) {
    e._x_undoAddedClasses && e._x_undoAddedClasses(), e._x_undoAddedClasses = st(e, t)
}

function Jr(e, t) {
    e._x_undoAddedStyles && e._x_undoAddedStyles(), e._x_undoAddedStyles = ye(e, t)
}

function Kr(e, t, n) {
    pn(e, t, n), Dr(e, t, n)
}

function pn(e, t, n) {
    [null, void 0, !1].includes(n) && Vr(t) ? e.removeAttribute(t) : (_n(t) && (n = t), Hr(e, t, n))
}

function Hr(e, t, n) {
    e.getAttribute(t) != n && e.setAttribute(t, n)
}

function Dr(e, t, n) {
    e[t] !== n && (e[t] = n)
}

function Fr(e, t) {
    const n = [].concat(t).map(i => i + "");
    Array.from(e.options).forEach(i => {
        i.selected = n.includes(i.value)
    })
}

function zr(e) {
    return e.toLowerCase().replace(/-(\w)/g, (t, n) => n.toUpperCase())
}

function bt(e, t) {
    return e == t
}

function pe(e) {
    return [1, "1", "true", "on", "yes", !0].includes(e) ? !0 : [0, "0", "false", "off", "no", !1].includes(e) ? !1 : e ? !!e : null
}
var Ur = new Set(["allowfullscreen", "async", "autofocus", "autoplay", "checked", "controls", "default", "defer", "disabled", "formnovalidate", "inert", "ismap", "itemscope", "loop", "multiple", "muted", "nomodule", "novalidate", "open", "playsinline", "readonly", "required", "reversed", "selected", "shadowrootclonable", "shadowrootdelegatesfocus", "shadowrootserializable"]);

function _n(e) {
    return Ur.has(e)
}

function Vr(e) {
    return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(e)
}

function Zr(e, t, n) {
    return e._x_bindings && e._x_bindings[t] !== void 0 ? e._x_bindings[t] : hn(e, t, n)
}

function $r(e, t, n, i = !0) {
    if (e._x_bindings && e._x_bindings[t] !== void 0) return e._x_bindings[t];
    if (e._x_inlineBindings && e._x_inlineBindings[t] !== void 0) {
        let c = e._x_inlineBindings[t];
        return c.extract = i, Dt(() => B(e, c.expression))
    }
    return hn(e, t, n)
}

function hn(e, t, n) {
    let i = e.getAttribute(t);
    return i === null ? typeof n == "function" ? n() : n : i === "" ? !0 : _n(t) ? !![t, "true"].includes(i) : i
}

function ut(e) {
    return e.type === "checkbox" || e.localName === "ui-checkbox" || e.localName === "ui-switch"
}

function mn(e) {
    return e.type === "radio" || e.localName === "ui-radio"
}

function gn(e, t) {
    let n;
    return function() {
        const i = this,
            c = arguments,
            o = function() {
                n = null, e.apply(i, c)
            };
        clearTimeout(n), n = setTimeout(o, t)
    }
}

function Sn(e, t) {
    let n;
    return function() {
        let i = this,
            c = arguments;
        n || (e.apply(i, c), n = !0, setTimeout(() => n = !1, t))
    }
}

function bn({
    get: e,
    set: t
}, {
    get: n,
    set: i
}) {
    let c = !0,
        o, r = H(() => {
            let a = e(),
                s = n();
            if (c) i(Re(a)), c = !1;
            else {
                let u = JSON.stringify(a),
                    l = JSON.stringify(s);
                u !== o ? i(Re(a)) : u !== l && t(Re(s))
            }
            o = JSON.stringify(e()), JSON.stringify(n())
        });
    return () => {
        U(r)
    }
}

function Re(e) {
    return typeof e == "object" ? JSON.parse(JSON.stringify(e)) : e
}

function Xr(e) {
    (Array.isArray(e) ? e : [e]).forEach(n => n(se))
}
var L = {},
    yt = !1;

function Yr(e, t) {
    if (yt || (L = z(L), yt = !0), t === void 0) return L[e];
    L[e] = t, Jt(L[e]), typeof t == "object" && t !== null && t.hasOwnProperty("init") && typeof t.init == "function" && L[e].init()
}

function ei() {
    return L
}
var yn = {};

function ti(e, t) {
    let n = typeof t != "function" ? () => t : t;
    return e instanceof Element ? vn(e, n()) : (yn[e] = n, () => {})
}

function ni(e) {
    return Object.entries(yn).forEach(([t, n]) => {
        Object.defineProperty(e, t, {
            get() {
                return (...i) => n(...i)
            }
        })
    }), e
}

function vn(e, t, n) {
    let i = [];
    for (; i.length;) i.pop()();
    let c = Object.entries(t).map(([r, a]) => ({
            name: r,
            value: a
        })),
        o = Ut(c);
    return c = c.map(r => o.find(a => a.name === r.name) ? {
        name: `x-bind:${r.name}`,
        value: `"${r.value}"`
    } : r), rt(e, c, n).map(r => {
        i.push(r.runCleanups), r()
    }), () => {
        for (; i.length;) i.pop()()
    }
}
var kn = {};

function ri(e, t) {
    kn[e] = t
}

function ii(e, t) {
    return Object.entries(kn).forEach(([n, i]) => {
        Object.defineProperty(e, n, {
            get() {
                return (...c) => i.bind(t)(...c)
            },
            enumerable: !1
        })
    }), e
}
var oi = {
        get reactive() {
            return z
        },
        get release() {
            return U
        },
        get effect() {
            return H
        },
        get raw() {
            return Mt
        },
        version: "3.15.0",
        flushAndStopDeferringMutations: ar,
        dontAutoEvaluateFunctions: Dt,
        disableEffectScheduling: er,
        startObservingMutations: Ye,
        stopObservingMutations: Bt,
        setReactivityEngine: tr,
        onAttributeRemoved: Tt,
        onAttributesAdded: Lt,
        closestDataStack: D,
        skipDuringClone: q,
        onlyDuringClone: qr,
        addRootSelector: an,
        addInitSelector: sn,
        interceptClone: ve,
        addScopeToNode: ce,
        deferMutations: cr,
        mapAttributes: it,
        evaluateLater: k,
        interceptInit: Cr,
        setEvaluator: xr,
        mergeProxies: ae,
        extractProp: $r,
        findClosest: Z,
        onElRemoved: Ze,
        closestRoot: be,
        destroyTree: $,
        interceptor: Kt,
        transition: He,
        setStyles: ye,
        mutateDom: b,
        directive: y,
        entangle: bn,
        throttle: Sn,
        debounce: gn,
        evaluate: B,
        initTree: M,
        nextTick: at,
        prefixed: V,
        prefix: hr,
        plugin: Xr,
        magic: R,
        store: Yr,
        start: vr,
        clone: Tr,
        cloneNode: Lr,
        bound: Zr,
        $data: jt,
        watch: Gt,
        walk: K,
        data: ri,
        bind: ti
    },
    se = oi;

function ci(e, t) {
    const n = Object.create(null),
        i = e.split(",");
    for (let c = 0; c < i.length; c++) n[i[c]] = !0;
    return c => !!n[c]
}
var ai = Object.freeze({}),
    si = Object.prototype.hasOwnProperty,
    ke = (e, t) => si.call(e, t),
    j = Array.isArray,
    ie = e => Cn(e) === "[object Map]",
    ui = e => typeof e == "string",
    ft = e => typeof e == "symbol",
    Ce = e => e !== null && typeof e == "object",
    fi = Object.prototype.toString,
    Cn = e => fi.call(e),
    wn = e => Cn(e).slice(8, -1),
    lt = e => ui(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e,
    li = e => {
        const t = Object.create(null);
        return n => t[n] || (t[n] = e(n))
    },
    di = li(e => e.charAt(0).toUpperCase() + e.slice(1)),
    On = (e, t) => e !== t && (e === e || t === t),
    Fe = new WeakMap,
    te = [],
    A, J = Symbol("iterate"),
    ze = Symbol("Map key iterate");

function xi(e) {
    return e && e._isEffect === !0
}

function Wi(e, t = ai) {
    xi(e) && (e = e.raw);
    const n = hi(e, t);
    return t.lazy || n(), n
}

function pi(e) {
    e.active && (Pn(e), e.options.onStop && e.options.onStop(), e.active = !1)
}
var _i = 0;

function hi(e, t) {
    const n = function() {
        if (!n.active) return e();
        if (!te.includes(n)) {
            Pn(n);
            try {
                return gi(), te.push(n), A = n, e()
            } finally {
                te.pop(), Rn(), A = te[te.length - 1]
            }
        }
    };
    return n.id = _i++, n.allowRecurse = !!t.allowRecurse, n._isEffect = !0, n.active = !0, n.raw = e, n.deps = [], n.options = t, n
}

function Pn(e) {
    const {
        deps: t
    } = e;
    if (t.length) {
        for (let n = 0; n < t.length; n++) t[n].delete(e);
        t.length = 0
    }
}
var F = !0,
    dt = [];

function mi() {
    dt.push(F), F = !1
}

function gi() {
    dt.push(F), F = !0
}

function Rn() {
    const e = dt.pop();
    F = e === void 0 ? !0 : e
}

function P(e, t, n) {
    if (!F || A === void 0) return;
    let i = Fe.get(e);
    i || Fe.set(e, i = new Map);
    let c = i.get(n);
    c || i.set(n, c = new Set), c.has(A) || (c.add(A), A.deps.push(c), A.options.onTrack && A.options.onTrack({
        effect: A,
        target: e,
        type: t,
        key: n
    }))
}

function I(e, t, n, i, c, o) {
    const r = Fe.get(e);
    if (!r) return;
    const a = new Set,
        s = l => {
            l && l.forEach(p => {
                (p !== A || p.allowRecurse) && a.add(p)
            })
        };
    if (t === "clear") r.forEach(s);
    else if (n === "length" && j(e)) r.forEach((l, p) => {
        (p === "length" || p >= i) && s(l)
    });
    else switch (n !== void 0 && s(r.get(n)), t) {
        case "add":
            j(e) ? lt(n) && s(r.get("length")) : (s(r.get(J)), ie(e) && s(r.get(ze)));
            break;
        case "delete":
            j(e) || (s(r.get(J)), ie(e) && s(r.get(ze)));
            break;
        case "set":
            ie(e) && s(r.get(J));
            break
    }
    const u = l => {
        l.options.onTrigger && l.options.onTrigger({
            effect: l,
            target: e,
            key: n,
            type: t,
            newValue: i,
            oldValue: c,
            oldTarget: o
        }), l.options.scheduler ? l.options.scheduler(l) : l()
    };
    a.forEach(u)
}
var Si = ci("__proto__,__v_isRef,__isVue"),
    An = new Set(Object.getOwnPropertyNames(Symbol).map(e => Symbol[e]).filter(ft)),
    bi = En(),
    yi = En(!0),
    vt = vi();

function vi() {
    const e = {};
    return ["includes", "indexOf", "lastIndexOf"].forEach(t => {
        e[t] = function(...n) {
            const i = g(this);
            for (let o = 0, r = this.length; o < r; o++) P(i, "get", o + "");
            const c = i[t](...n);
            return c === -1 || c === !1 ? i[t](...n.map(g)) : c
        }
    }), ["push", "pop", "shift", "unshift", "splice"].forEach(t => {
        e[t] = function(...n) {
            mi();
            const i = g(this)[t].apply(this, n);
            return Rn(), i
        }
    }), e
}

function En(e = !1, t = !1) {
    return function(i, c, o) {
        if (c === "__v_isReactive") return !e;
        if (c === "__v_isReadonly") return e;
        if (c === "__v_raw" && o === (e ? t ? Li : In : t ? qi : Qn).get(i)) return i;
        const r = j(i);
        if (!e && r && ke(vt, c)) return Reflect.get(vt, c, o);
        const a = Reflect.get(i, c, o);
        return (ft(c) ? An.has(c) : Si(c)) || (e || P(i, "get", c), t) ? a : Ue(a) ? !r || !lt(c) ? a.value : a : Ce(a) ? e ? qn(a) : _t(a) : a
    }
}
var ki = Ci();

function Ci(e = !1) {
    return function(n, i, c, o) {
        let r = n[i];
        if (!e && (c = g(c), r = g(r), !j(n) && Ue(r) && !Ue(c))) return r.value = c, !0;
        const a = j(n) && lt(i) ? Number(i) < n.length : ke(n, i),
            s = Reflect.set(n, i, c, o);
        return n === g(o) && (a ? On(c, r) && I(n, "set", i, c, r) : I(n, "add", i, c)), s
    }
}

function wi(e, t) {
    const n = ke(e, t),
        i = e[t],
        c = Reflect.deleteProperty(e, t);
    return c && n && I(e, "delete", t, void 0, i), c
}

function Oi(e, t) {
    const n = Reflect.has(e, t);
    return (!ft(t) || !An.has(t)) && P(e, "has", t), n
}

function Pi(e) {
    return P(e, "iterate", j(e) ? "length" : J), Reflect.ownKeys(e)
}
var Ri = {
        get: bi,
        set: ki,
        deleteProperty: wi,
        has: Oi,
        ownKeys: Pi
    },
    Ai = {
        get: yi,
        set(e, t) {
            return console.warn(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0
        },
        deleteProperty(e, t) {
            return console.warn(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0
        }
    },
    xt = e => Ce(e) ? _t(e) : e,
    Wt = e => Ce(e) ? qn(e) : e,
    pt = e => e,
    we = e => Reflect.getPrototypeOf(e);

function ue(e, t, n = !1, i = !1) {
    e = e.__v_raw;
    const c = g(e),
        o = g(t);
    t !== o && !n && P(c, "get", t), !n && P(c, "get", o);
    const {
        has: r
    } = we(c), a = i ? pt : n ? Wt : xt;
    if (r.call(c, t)) return a(e.get(t));
    if (r.call(c, o)) return a(e.get(o));
    e !== c && e.get(t)
}

function fe(e, t = !1) {
    const n = this.__v_raw,
        i = g(n),
        c = g(e);
    return e !== c && !t && P(i, "has", e), !t && P(i, "has", c), e === c ? n.has(e) : n.has(e) || n.has(c)
}

function le(e, t = !1) {
    return e = e.__v_raw, !t && P(g(e), "iterate", J), Reflect.get(e, "size", e)
}

function kt(e) {
    e = g(e);
    const t = g(this);
    return we(t).has.call(t, e) || (t.add(e), I(t, "add", e, e)), this
}

function Ct(e, t) {
    t = g(t);
    const n = g(this),
        {
            has: i,
            get: c
        } = we(n);
    let o = i.call(n, e);
    o ? Gn(n, i, e) : (e = g(e), o = i.call(n, e));
    const r = c.call(n, e);
    return n.set(e, t), o ? On(t, r) && I(n, "set", e, t, r) : I(n, "add", e, t), this
}

function wt(e) {
    const t = g(this),
        {
            has: n,
            get: i
        } = we(t);
    let c = n.call(t, e);
    c ? Gn(t, n, e) : (e = g(e), c = n.call(t, e));
    const o = i ? i.call(t, e) : void 0,
        r = t.delete(e);
    return c && I(t, "delete", e, void 0, o), r
}

function Ot() {
    const e = g(this),
        t = e.size !== 0,
        n = ie(e) ? new Map(e) : new Set(e),
        i = e.clear();
    return t && I(e, "clear", void 0, void 0, n), i
}

function de(e, t) {
    return function(i, c) {
        const o = this,
            r = o.__v_raw,
            a = g(r),
            s = t ? pt : e ? Wt : xt;
        return !e && P(a, "iterate", J), r.forEach((u, l) => i.call(c, s(u), s(l), o))
    }
}

function xe(e, t, n) {
    return function(...i) {
        const c = this.__v_raw,
            o = g(c),
            r = ie(o),
            a = e === "entries" || e === Symbol.iterator && r,
            s = e === "keys" && r,
            u = c[e](...i),
            l = n ? pt : t ? Wt : xt;
        return !t && P(o, "iterate", s ? ze : J), {
            next() {
                const {
                    value: p,
                    done: h
                } = u.next();
                return h ? {
                    value: p,
                    done: h
                } : {
                    value: a ? [l(p[0]), l(p[1])] : l(p),
                    done: h
                }
            },
            [Symbol.iterator]() {
                return this
            }
        }
    }
}

function G(e) {
    return function(...t) {
        {
            const n = t[0] ? `on key "${t[0]}" ` : "";
            console.warn(`${di(e)} operation ${n}failed: target is readonly.`, g(this))
        }
        return e === "delete" ? !1 : this
    }
}

function Ei() {
    const e = {
            get(o) {
                return ue(this, o)
            },
            get size() {
                return le(this)
            },
            has: fe,
            add: kt,
            set: Ct,
            delete: wt,
            clear: Ot,
            forEach: de(!1, !1)
        },
        t = {
            get(o) {
                return ue(this, o, !1, !0)
            },
            get size() {
                return le(this)
            },
            has: fe,
            add: kt,
            set: Ct,
            delete: wt,
            clear: Ot,
            forEach: de(!1, !0)
        },
        n = {
            get(o) {
                return ue(this, o, !0)
            },
            get size() {
                return le(this, !0)
            },
            has(o) {
                return fe.call(this, o, !0)
            },
            add: G("add"),
            set: G("set"),
            delete: G("delete"),
            clear: G("clear"),
            forEach: de(!0, !1)
        },
        i = {
            get(o) {
                return ue(this, o, !0, !0)
            },
            get size() {
                return le(this, !0)
            },
            has(o) {
                return fe.call(this, o, !0)
            },
            add: G("add"),
            set: G("set"),
            delete: G("delete"),
            clear: G("clear"),
            forEach: de(!0, !0)
        };
    return ["keys", "values", "entries", Symbol.iterator].forEach(o => {
        e[o] = xe(o, !1, !1), n[o] = xe(o, !0, !1), t[o] = xe(o, !1, !0), i[o] = xe(o, !0, !0)
    }), [e, n, t, i]
}
var [Mi, Gi] = Ei();

function Mn(e, t) {
    const n = e ? Gi : Mi;
    return (i, c, o) => c === "__v_isReactive" ? !e : c === "__v_isReadonly" ? e : c === "__v_raw" ? i : Reflect.get(ke(n, c) && c in i ? n : i, c, o)
}
var Qi = {
        get: Mn(!1)
    },
    Ii = {
        get: Mn(!0)
    };

function Gn(e, t, n) {
    const i = g(n);
    if (i !== n && t.call(e, i)) {
        const c = wn(e);
        console.warn(`Reactive ${c} contains both the raw and reactive versions of the same object${c==="Map"?" as keys":""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`)
    }
}
var Qn = new WeakMap,
    qi = new WeakMap,
    In = new WeakMap,
    Li = new WeakMap;

function Ti(e) {
    switch (e) {
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0
    }
}

function Ni(e) {
    return e.__v_skip || !Object.isExtensible(e) ? 0 : Ti(wn(e))
}

function _t(e) {
    return e && e.__v_isReadonly ? e : Ln(e, !1, Ri, Qi, Qn)
}

function qn(e) {
    return Ln(e, !0, Ai, Ii, In)
}

function Ln(e, t, n, i, c) {
    if (!Ce(e)) return console.warn(`value cannot be made reactive: ${String(e)}`), e;
    if (e.__v_raw && !(t && e.__v_isReactive)) return e;
    const o = c.get(e);
    if (o) return o;
    const r = Ni(e);
    if (r === 0) return e;
    const a = new Proxy(e, r === 2 ? i : n);
    return c.set(e, a), a
}

function g(e) {
    return e && g(e.__v_raw) || e
}

function Ue(e) {
    return !!(e && e.__v_isRef === !0)
}
R("nextTick", () => at);
R("dispatch", e => re.bind(re, e));
R("watch", (e, {
    evaluateLater: t,
    cleanup: n
}) => (i, c) => {
    let o = t(i),
        a = Gt(() => {
            let s;
            return o(u => s = u), s
        }, c);
    n(a)
});
R("store", ei);
R("data", e => jt(e));
R("root", e => be(e));
R("refs", e => (e._x_refs_proxy || (e._x_refs_proxy = ae(Bi(e))), e._x_refs_proxy));

function Bi(e) {
    let t = [];
    return Z(e, n => {
        n._x_refs && t.push(n._x_refs)
    }), t
}
var Ae = {};

function Tn(e) {
    return Ae[e] || (Ae[e] = 0), ++Ae[e]
}

function ji(e, t) {
    return Z(e, n => {
        if (n._x_ids && n._x_ids[t]) return !0
    })
}

function Ji(e, t) {
    e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = Tn(t))
}
R("id", (e, {
    cleanup: t
}) => (n, i = null) => {
    let c = `${n}${i?`-${i}`:""}`;
    return Ki(e, c, t, () => {
        let o = ji(e, n),
            r = o ? o._x_ids[n] : Tn(n);
        return i ? `${n}-${r}-${i}` : `${n}-${r}`
    })
});
ve((e, t) => {
    e._x_id && (t._x_id = e._x_id)
});

function Ki(e, t, n, i) {
    if (e._x_id || (e._x_id = {}), e._x_id[t]) return e._x_id[t];
    let c = i();
    return e._x_id[t] = c, n(() => {
        delete e._x_id[t]
    }), c
}
R("el", e => e);
Nn("Focus", "focus", "focus");
Nn("Persist", "persist", "persist");

function Nn(e, t, n) {
    R(t, i => C(`You can't use [$${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`, i))
}
y("modelable", (e, {
    expression: t
}, {
    effect: n,
    evaluateLater: i,
    cleanup: c
}) => {
    let o = i(t),
        r = () => {
            let l;
            return o(p => l = p), l
        },
        a = i(`${t} = __placeholder`),
        s = l => a(() => {}, {
            scope: {
                __placeholder: l
            }
        }),
        u = r();
    s(u), queueMicrotask(() => {
        if (!e._x_model) return;
        e._x_removeModelListeners.default();
        let l = e._x_model.get,
            p = e._x_model.set,
            h = bn({
                get() {
                    return l()
                },
                set(_) {
                    p(_)
                }
            }, {
                get() {
                    return r()
                },
                set(_) {
                    s(_)
                }
            });
        c(h)
    })
});
y("teleport", (e, {
    modifiers: t,
    expression: n
}, {
    cleanup: i
}) => {
    e.tagName.toLowerCase() !== "template" && C("x-teleport can only be used on a <template> tag", e);
    let c = Pt(n),
        o = e.content.cloneNode(!0).firstElementChild;
    e._x_teleport = o, o._x_teleportBack = e, e.setAttribute("data-teleport-template", !0), o.setAttribute("data-teleport-target", !0), e._x_forwardEvents && e._x_forwardEvents.forEach(a => {
        o.addEventListener(a, s => {
            s.stopPropagation(), e.dispatchEvent(new s.constructor(s.type, s))
        })
    }), ce(o, {}, e);
    let r = (a, s, u) => {
        u.includes("prepend") ? s.parentNode.insertBefore(a, s) : u.includes("append") ? s.parentNode.insertBefore(a, s.nextSibling) : s.appendChild(a)
    };
    b(() => {
        r(o, c, t), q(() => {
            M(o)
        })()
    }), e._x_teleportPutBack = () => {
        let a = Pt(n);
        b(() => {
            r(e._x_teleport, a, t)
        })
    }, i(() => b(() => {
        o.remove(), $(o)
    }))
});
var Hi = document.createElement("div");

function Pt(e) {
    let t = q(() => document.querySelector(e), () => Hi)();
    return t || C(`Cannot find x-teleport element for selector: "${e}"`), t
}
var Bn = () => {};
Bn.inline = (e, {
    modifiers: t
}, {
    cleanup: n
}) => {
    t.includes("self") ? e._x_ignoreSelf = !0 : e._x_ignore = !0, n(() => {
        t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore
    })
};
y("ignore", Bn);
y("effect", q((e, {
    expression: t
}, {
    effect: n
}) => {
    n(k(e, t))
}));

function Ve(e, t, n, i) {
    let c = e,
        o = s => i(s),
        r = {},
        a = (s, u) => l => u(s, l);
    if (n.includes("dot") && (t = Di(t)), n.includes("camel") && (t = Fi(t)), n.includes("passive") && (r.passive = !0), n.includes("capture") && (r.capture = !0), n.includes("window") && (c = window), n.includes("document") && (c = document), n.includes("debounce")) {
        let s = n[n.indexOf("debounce") + 1] || "invalid-wait",
            u = ge(s.split("ms")[0]) ? Number(s.split("ms")[0]) : 250;
        o = gn(o, u)
    }
    if (n.includes("throttle")) {
        let s = n[n.indexOf("throttle") + 1] || "invalid-wait",
            u = ge(s.split("ms")[0]) ? Number(s.split("ms")[0]) : 250;
        o = Sn(o, u)
    }
    return n.includes("prevent") && (o = a(o, (s, u) => {
        u.preventDefault(), s(u)
    })), n.includes("stop") && (o = a(o, (s, u) => {
        u.stopPropagation(), s(u)
    })), n.includes("once") && (o = a(o, (s, u) => {
        s(u), c.removeEventListener(t, o, r)
    })), (n.includes("away") || n.includes("outside")) && (c = document, o = a(o, (s, u) => {
        e.contains(u.target) || u.target.isConnected !== !1 && (e.offsetWidth < 1 && e.offsetHeight < 1 || e._x_isShown !== !1 && s(u))
    })), n.includes("self") && (o = a(o, (s, u) => {
        u.target === e && s(u)
    })), (Ui(t) || jn(t)) && (o = a(o, (s, u) => {
        Vi(u, n) || s(u)
    })), c.addEventListener(t, o, r), () => {
        c.removeEventListener(t, o, r)
    }
}

function Di(e) {
    return e.replace(/-/g, ".")
}

function Fi(e) {
    return e.toLowerCase().replace(/-(\w)/g, (t, n) => n.toUpperCase())
}

function ge(e) {
    return !Array.isArray(e) && !isNaN(e)
}

function zi(e) {
    return [" ", "_"].includes(e) ? e : e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase()
}

function Ui(e) {
    return ["keydown", "keyup"].includes(e)
}

function jn(e) {
    return ["contextmenu", "click", "mouse"].some(t => e.includes(t))
}

function Vi(e, t) {
    let n = t.filter(o => !["window", "document", "prevent", "stop", "once", "capture", "self", "away", "outside", "passive", "preserve-scroll"].includes(o));
    if (n.includes("debounce")) {
        let o = n.indexOf("debounce");
        n.splice(o, ge((n[o + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1)
    }
    if (n.includes("throttle")) {
        let o = n.indexOf("throttle");
        n.splice(o, ge((n[o + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1)
    }
    if (n.length === 0 || n.length === 1 && Rt(e.key).includes(n[0])) return !1;
    const c = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter(o => n.includes(o));
    return n = n.filter(o => !c.includes(o)), !(c.length > 0 && c.filter(r => ((r === "cmd" || r === "super") && (r = "meta"), e[`${r}Key`])).length === c.length && (jn(e.type) || Rt(e.key).includes(n[0])))
}

function Rt(e) {
    if (!e) return [];
    e = zi(e);
    let t = {
        ctrl: "control",
        slash: "/",
        space: " ",
        spacebar: " ",
        cmd: "meta",
        esc: "escape",
        up: "arrow-up",
        down: "arrow-down",
        left: "arrow-left",
        right: "arrow-right",
        period: ".",
        comma: ",",
        equal: "=",
        minus: "-",
        underscore: "_"
    };
    return t[e] = e, Object.keys(t).map(n => {
        if (t[n] === e) return n
    }).filter(n => n)
}
y("model", (e, {
    modifiers: t,
    expression: n
}, {
    effect: i,
    cleanup: c
}) => {
    let o = e;
    t.includes("parent") && (o = e.parentNode);
    let r = k(o, n),
        a;
    typeof n == "string" ? a = k(o, `${n} = __placeholder`) : typeof n == "function" && typeof n() == "string" ? a = k(o, `${n()} = __placeholder`) : a = () => {};
    let s = () => {
            let h;
            return r(_ => h = _), At(h) ? h.get() : h
        },
        u = h => {
            let _;
            r(f => _ = f), At(_) ? _.set(h) : a(() => {}, {
                scope: {
                    __placeholder: h
                }
            })
        };
    typeof n == "string" && e.type === "radio" && b(() => {
        e.hasAttribute("name") || e.setAttribute("name", n)
    });
    let l = e.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(e.type) || t.includes("lazy") ? "change" : "input",
        p = Q ? () => {} : Ve(e, l, t, h => {
            u(Ee(e, t, h, s()))
        });
    if (t.includes("fill") && ([void 0, null, ""].includes(s()) || ut(e) && Array.isArray(s()) || e.tagName.toLowerCase() === "select" && e.multiple) && u(Ee(e, t, {
            target: e
        }, s())), e._x_removeModelListeners || (e._x_removeModelListeners = {}), e._x_removeModelListeners.default = p, c(() => e._x_removeModelListeners.default()), e.form) {
        let h = Ve(e.form, "reset", [], _ => {
            at(() => e._x_model && e._x_model.set(Ee(e, t, {
                target: e
            }, s())))
        });
        c(() => h())
    }
    e._x_model = {
        get() {
            return s()
        },
        set(h) {
            u(h)
        }
    }, e._x_forceModelUpdate = h => {
        h === void 0 && typeof n == "string" && n.match(/\./) && (h = ""), window.fromModel = !0, b(() => Wn(e, "value", h)), delete window.fromModel
    }, i(() => {
        let h = s();
        t.includes("unintrusive") && document.activeElement.isSameNode(e) || e._x_forceModelUpdate(h)
    })
});

function Ee(e, t, n, i) {
    return b(() => {
        if (n instanceof CustomEvent && n.detail !== void 0) return n.detail !== null && n.detail !== void 0 ? n.detail : n.target.value;
        if (ut(e))
            if (Array.isArray(i)) {
                let c = null;
                return t.includes("number") ? c = Me(n.target.value) : t.includes("boolean") ? c = pe(n.target.value) : c = n.target.value, n.target.checked ? i.includes(c) ? i : i.concat([c]) : i.filter(o => !Zi(o, c))
            } else return n.target.checked;
        else {
            if (e.tagName.toLowerCase() === "select" && e.multiple) return t.includes("number") ? Array.from(n.target.selectedOptions).map(c => {
                let o = c.value || c.text;
                return Me(o)
            }) : t.includes("boolean") ? Array.from(n.target.selectedOptions).map(c => {
                let o = c.value || c.text;
                return pe(o)
            }) : Array.from(n.target.selectedOptions).map(c => c.value || c.text);
            {
                let c;
                return mn(e) ? n.target.checked ? c = n.target.value : c = i : c = n.target.value, t.includes("number") ? Me(c) : t.includes("boolean") ? pe(c) : t.includes("trim") ? c.trim() : c
            }
        }
    })
}

function Me(e) {
    let t = e ? parseFloat(e) : null;
    return $i(t) ? t : e
}

function Zi(e, t) {
    return e == t
}

function $i(e) {
    return !Array.isArray(e) && !isNaN(e)
}

function At(e) {
    return e !== null && typeof e == "object" && typeof e.get == "function" && typeof e.set == "function"
}
y("cloak", e => queueMicrotask(() => b(() => e.removeAttribute(V("cloak")))));
sn(() => `[${V("init")}]`);
y("init", q((e, {
    expression: t
}, {
    evaluate: n
}) => typeof t == "string" ? !!t.trim() && n(t, {}, !1) : n(t, {}, !1)));
y("text", (e, {
    expression: t
}, {
    effect: n,
    evaluateLater: i
}) => {
    let c = i(t);
    n(() => {
        c(o => {
            b(() => {
                e.textContent = o
            })
        })
    })
});
y("html", (e, {
    expression: t
}, {
    effect: n,
    evaluateLater: i
}) => {
    let c = i(t);
    n(() => {
        c(o => {
            b(() => {
                e.innerHTML = o, e._x_ignoreSelf = !0, M(e), delete e._x_ignoreSelf
            })
        })
    })
});
it($t(":", Xt(V("bind:"))));
var Jn = (e, {
    value: t,
    modifiers: n,
    expression: i,
    original: c
}, {
    effect: o,
    cleanup: r
}) => {
    if (!t) {
        let s = {};
        ni(s), k(e, i)(l => {
            vn(e, l, c)
        }, {
            scope: s
        });
        return
    }
    if (t === "key") return Xi(e, i);
    if (e._x_inlineBindings && e._x_inlineBindings[t] && e._x_inlineBindings[t].extract) return;
    let a = k(e, i);
    o(() => a(s => {
        s === void 0 && typeof i == "string" && i.match(/\./) && (s = ""), b(() => Wn(e, t, s, n))
    })), r(() => {
        e._x_undoAddedClasses && e._x_undoAddedClasses(), e._x_undoAddedStyles && e._x_undoAddedStyles()
    })
};
Jn.inline = (e, {
    value: t,
    modifiers: n,
    expression: i
}) => {
    t && (e._x_inlineBindings || (e._x_inlineBindings = {}), e._x_inlineBindings[t] = {
        expression: i,
        extract: !1
    })
};
y("bind", Jn);

function Xi(e, t) {
    e._x_keyExpression = t
}
an(() => `[${V("data")}]`);
y("data", (e, {
    expression: t
}, {
    cleanup: n
}) => {
    if (Yi(e)) return;
    t = t === "" ? "{}" : t;
    let i = {};
    Te(i, e);
    let c = {};
    ii(c, i);
    let o = B(e, t, {
        scope: c
    });
    (o === void 0 || o === !0) && (o = {}), Te(o, e);
    let r = z(o);
    Jt(r);
    let a = ce(e, r);
    r.init && B(e, r.init), n(() => {
        r.destroy && B(e, r.destroy), a()
    })
});
ve((e, t) => {
    e._x_dataStack && (t._x_dataStack = e._x_dataStack, t.setAttribute("data-has-alpine-state", !0))
});

function Yi(e) {
    return Q ? De ? !0 : e.hasAttribute("data-has-alpine-state") : !1
}
y("show", (e, {
    modifiers: t,
    expression: n
}, {
    effect: i
}) => {
    let c = k(e, n);
    e._x_doHide || (e._x_doHide = () => {
        b(() => {
            e.style.setProperty("display", "none", t.includes("important") ? "important" : void 0)
        })
    }), e._x_doShow || (e._x_doShow = () => {
        b(() => {
            e.style.length === 1 && e.style.display === "none" ? e.removeAttribute("style") : e.style.removeProperty("display")
        })
    });
    let o = () => {
            e._x_doHide(), e._x_isShown = !1
        },
        r = () => {
            e._x_doShow(), e._x_isShown = !0
        },
        a = () => setTimeout(r),
        s = Ke(p => p ? r() : o(), p => {
            typeof e._x_toggleAndCascadeWithTransitions == "function" ? e._x_toggleAndCascadeWithTransitions(e, p, r, o) : p ? a() : o()
        }),
        u, l = !0;
    i(() => c(p => {
        !l && p === u || (t.includes("immediate") && (p ? a() : o()), s(p), u = p, l = !1)
    }))
});
y("for", (e, {
    expression: t
}, {
    effect: n,
    cleanup: i
}) => {
    let c = to(t),
        o = k(e, c.items),
        r = k(e, e._x_keyExpression || "index");
    e._x_prevKeys = [], e._x_lookup = {}, n(() => eo(e, c, o, r)), i(() => {
        Object.values(e._x_lookup).forEach(a => b(() => {
            $(a), a.remove()
        })), delete e._x_prevKeys, delete e._x_lookup
    })
});

function eo(e, t, n, i) {
    let c = r => typeof r == "object" && !Array.isArray(r),
        o = e;
    n(r => {
        no(r) && r >= 0 && (r = Array.from(Array(r).keys(), x => x + 1)), r === void 0 && (r = []);
        let a = e._x_lookup,
            s = e._x_prevKeys,
            u = [],
            l = [];
        if (c(r)) r = Object.entries(r).map(([x, W]) => {
            let m = Et(t, W, x, r);
            i(S => {
                l.includes(S) && C("Duplicate key on x-for", e), l.push(S)
            }, {
                scope: {
                    index: x,
                    ...m
                }
            }), u.push(m)
        });
        else
            for (let x = 0; x < r.length; x++) {
                let W = Et(t, r[x], x, r);
                i(m => {
                    l.includes(m) && C("Duplicate key on x-for", e), l.push(m)
                }, {
                    scope: {
                        index: x,
                        ...W
                    }
                }), u.push(W)
            }
        let p = [],
            h = [],
            _ = [],
            f = [];
        for (let x = 0; x < s.length; x++) {
            let W = s[x];
            l.indexOf(W) === -1 && _.push(W)
        }
        s = s.filter(x => !_.includes(x));
        let d = "template";
        for (let x = 0; x < l.length; x++) {
            let W = l[x],
                m = s.indexOf(W);
            if (m === -1) s.splice(x, 0, W), p.push([d, x]);
            else if (m !== x) {
                let S = s.splice(x, 1)[0],
                    v = s.splice(m - 1, 1)[0];
                s.splice(x, 0, v), s.splice(m, 0, S), h.push([S, v])
            } else f.push(W);
            d = W
        }
        for (let x = 0; x < _.length; x++) {
            let W = _[x];
            W in a && (b(() => {
                $(a[W]), a[W].remove()
            }), delete a[W])
        }
        for (let x = 0; x < h.length; x++) {
            let [W, m] = h[x], S = a[W], v = a[m], E = document.createElement("div");
            b(() => {
                v || C('x-for ":key" is undefined or invalid', o, m, a), v.after(E), S.after(v), v._x_currentIfEl && v.after(v._x_currentIfEl), E.before(S), S._x_currentIfEl && S.after(S._x_currentIfEl), E.remove()
            }), v._x_refreshXForScope(u[l.indexOf(m)])
        }
        for (let x = 0; x < p.length; x++) {
            let [W, m] = p[x], S = W === "template" ? o : a[W];
            S._x_currentIfEl && (S = S._x_currentIfEl);
            let v = u[m],
                E = l[m],
                X = document.importNode(o.content, !0).firstElementChild,
                ht = z(v);
            ce(X, ht, o), X._x_refreshXForScope = Dn => {
                Object.entries(Dn).forEach(([Fn, zn]) => {
                    ht[Fn] = zn
                })
            }, b(() => {
                S.after(X), q(() => M(X))()
            }), typeof E == "object" && C("x-for key cannot be an object, it must be a string or an integer", o), a[E] = X
        }
        for (let x = 0; x < f.length; x++) a[f[x]]._x_refreshXForScope(u[l.indexOf(f[x])]);
        o._x_prevKeys = l
    })
}

function to(e) {
    let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
        n = /^\s*\(|\)\s*$/g,
        i = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
        c = e.match(i);
    if (!c) return;
    let o = {};
    o.items = c[2].trim();
    let r = c[1].replace(n, "").trim(),
        a = r.match(t);
    return a ? (o.item = r.replace(t, "").trim(), o.index = a[1].trim(), a[2] && (o.collection = a[2].trim())) : o.item = r, o
}

function Et(e, t, n, i) {
    let c = {};
    return /^\[.*\]$/.test(e.item) && Array.isArray(t) ? e.item.replace("[", "").replace("]", "").split(",").map(r => r.trim()).forEach((r, a) => {
        c[r] = t[a]
    }) : /^\{.*\}$/.test(e.item) && !Array.isArray(t) && typeof t == "object" ? e.item.replace("{", "").replace("}", "").split(",").map(r => r.trim()).forEach(r => {
        c[r] = t[r]
    }) : c[e.item] = t, e.index && (c[e.index] = n), e.collection && (c[e.collection] = i), c
}

function no(e) {
    return !Array.isArray(e) && !isNaN(e)
}

function Kn() {}
Kn.inline = (e, {
    expression: t
}, {
    cleanup: n
}) => {
    let i = be(e);
    i._x_refs || (i._x_refs = {}), i._x_refs[t] = e, n(() => delete i._x_refs[t])
};
y("ref", Kn);
y("if", (e, {
    expression: t
}, {
    effect: n,
    cleanup: i
}) => {
    e.tagName.toLowerCase() !== "template" && C("x-if can only be used on a <template> tag", e);
    let c = k(e, t),
        o = () => {
            if (e._x_currentIfEl) return e._x_currentIfEl;
            let a = e.content.cloneNode(!0).firstElementChild;
            return ce(a, {}, e), b(() => {
                e.after(a), q(() => M(a))()
            }), e._x_currentIfEl = a, e._x_undoIf = () => {
                b(() => {
                    $(a), a.remove()
                }), delete e._x_currentIfEl
            }, a
        },
        r = () => {
            e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf)
        };
    n(() => c(a => {
        a ? o() : r()
    })), i(() => e._x_undoIf && e._x_undoIf())
});
y("id", (e, {
    expression: t
}, {
    evaluate: n
}) => {
    n(t).forEach(c => Ji(e, c))
});
ve((e, t) => {
    e._x_ids && (t._x_ids = e._x_ids)
});
it($t("@", Xt(V("on:"))));
y("on", q((e, {
    value: t,
    modifiers: n,
    expression: i
}, {
    cleanup: c
}) => {
    let o = i ? k(e, i) : () => {};
    e.tagName.toLowerCase() === "template" && (e._x_forwardEvents || (e._x_forwardEvents = []), e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
    let r = Ve(e, t, n, a => {
        o(() => {}, {
            scope: {
                $event: a
            },
            params: [a]
        })
    });
    c(() => r())
}));
Oe("Collapse", "collapse", "collapse");
Oe("Intersect", "intersect", "intersect");
Oe("Focus", "trap", "focus");
Oe("Mask", "mask", "mask");

function Oe(e, t, n) {
    y(t, i => C(`You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`, i))
}
se.setEvaluator(zt);
se.setReactivityEngine({
    reactive: _t,
    effect: Wi,
    release: pi,
    raw: g
});
var ro = se,
    Hn = ro;
window.Alpine = Hn;
const io = {
    FREE_GIFT_STORE: "freeGiftStore"
};
window.AlpineStoreKeys = io;
